<div class="page-view">
  <div
    class="wrap-grid template-background"
    [ngStyle]="{ 'background-image': 'url(' + imageSrc + ')' }"
  >
    <div class="cc-grid" [ngStyle]="grid.getGridStyle()">
      <ng-container *ngFor="let cell of grid.cells">
        <app-cc-cell-template
          *ngIf="cell.data.visible"
          [cellId]="grid.cells.indexOf(cell)"
          [grid]="grid"
          [ngStyle]="cell.getStyle()"
          [idCatalog]="undefined"
          [idFascicle]="undefined"
          [idPage]="undefined"
          [locked]="locked"
          (changeCell)="changeCell($event)"
        ></app-cc-cell-template>
      </ng-container>
    </div>
  </div>
</div>
